import { gql } from 'apollo-angular';

export const consumerNavigation = gql`
  fragment User on User {
    id
    truncatedName
    coordinator {
      truncatedName
    }
    profile {
      ... on ClientProfile {
        id
        coordinatorManaged
        participantRelationship
        participantAttributes {
          id
          truncatedName
          firstName
          lastName
        }
      }
    }
  }
`;

export const personalDetails = gql`
  fragment User on User {
    id
    firstName
    lastName
    contactPhone
    birthDate
    profile {
      ... on ClientProfile {
        id
        participantRelationship
        participantAddressLine1
        participantAddressLine2
        participantState
        participantPostcode
        behaviourSupportPlan
        typeOfCare
        participantAttributes {
          id
          firstName
          lastName
          gender
          birthDate
          contactPhone
          preferredName
        }
      }
    }
  }
`;

export const personReceivingSupport = gql`
  fragment User on User {
    id
    profile {
      ... on ClientProfile {
        id
        participantRelationship
        participantAttributes {
          id
          firstName
          lastName
          gender
          birthDate
          contactPhone
          preferredName
        }
      }
    }
  }
`;

export const supportTakePlace = gql`
  fragment User on User {
    id
    profile {
      ... on ClientProfile {
        id
        participantAddressLine1
        participantAddressLine2
        participantState
        participantPostcode
      }
    }
  }
`;

export const behaviourSupportPlan = gql`
  fragment User on User {
    id
    profile {
      ... on ClientProfile {
        id
        behaviourSupportPlan
        participantRelationship
        participantAttributes {
          id
          firstName
        }
      }
    }
  }
`;

export const personManagingAccount = gql`
  fragment User on User {
    id
    firstName
    lastName
    contactPhone
    birthDate
    primaryEmergencyContact
    profile {
      ... on ClientProfile {
        id
        participantRelationship
        participantAttributes {
          id
          firstName
          lastName
          gender
          contactPhone
          birthDate
        }
      }
    }
  }
`;

export const contacts = gql`
  fragment User on User {
    firstName
    lastName
    profile {
      ... on ClientProfile {
        id
        participantRelationship
        participantAttributes {
          firstName
          lastName
        }
        contactsAttributes {
          id
          relationshipCode
          name
          phone
          email
          emergency
          authorisedInformation
        }
      }
    }
  }
`;

export const paymentDetails = gql`
  fragment User on User {
    paymentToken
    profile {
      ... on ClientProfile {
        id
        coordinatorManaged
        participantRelationship
        paymentMethodCode
        fundingSourceCode
        assignPartnerFundingOrganisation
        organisationRequest {
          name
          email
          phone
        }
        ndisNumber
        invoiceReferenceNumber
        invoiceEmailsCc
        authoriseCc
        bankAccountDetailsName
        bankAccountDetailsBank
        bankAccountDetailsBsb
        bankAccountDetailsAccountNumber
        hasAsset {
          ndisLetter
          directDebit
        }
      }
    }
  }
`;

export const PaymentFundingInformation = gql`
  fragment User on User {
    profile {
      ... on ClientProfile {
        id
        coordinatorManaged
        participantRelationship
        paymentMethodCode
        fundingSourceCode
        coordinatorNdisAgencyManaged
      }
    }
  }
`;

export const PaymentUploadAuthorisationForm = gql`
  fragment User on User {
    profile {
      ... on ClientProfile {
        id
        coordinatorManaged
        participantRelationship
      }
    }
  }
`;

export const paymentDebitCard = gql`
  fragment User on User {
    profile {
      ... on ClientProfile {
        id
        bankAccountDetailsName
        bankAccountDetailsBank
        bankAccountDetailsBsb
        bankAccountDetailsAccountNumber
      }
    }
  }
`;

export const paymentCreditCard = gql`
  fragment User on User {
    paymentToken
    profile {
      ... on ClientProfile {
        id
        authoriseCc
        balancePaymentAcknowledgeDate
      }
    }
  }
`;

export const PaymentInvoice = gql`
  fragment User on User {
    profile {
      ... on ClientProfile {
        id
        fundingSourceCode
        invoiceReferenceNumber
        invoiceEmailsCc
        receiveCopyInvoiceReceiptEmail
        paymentMethodCode
        coordinatorManaged
      }
    }
  }
`;

export const PaymentNdisnumber = gql`
  fragment User on User {
    profile {
      ... on ClientProfile {
        id
        ndisNumber
        fundingSourceCode
      }
    }
  }
`;

export const paymentHomeCarePackageProvider = gql`
  fragment User on User {
    profile {
      ... on ClientProfile {
        id
        assignPartnerFundingOrganisation
      }
    }
  }
`;

export const PaymentHowToVerify = gql`
  fragment User on User {
    profile {
      ... on ClientProfile {
        id
        paymentMethodCode
        fundingSourceCode
      }
    }
  }
`;

export const supportNeeds = gql`
  fragment User on User {
    id
    profile {
      ... on ClientProfile {
        id
        participantRelationship
        participantAddressLine1
        participantAddressLine2
        participantState
        participantPostcode
        behaviourSupportPlan
        typeOfCare
        participantAttributes {
          id
          firstName
          medicalConcerns
          instructionsForCarer
          medicationJson {
            dosage
            frequency
            medication
            reasonTaken
          }
        }
        hasAsset {
          supportNeedDocuments
        }
      }
    }
  }
`;

export const jobPosted = gql`
  fragment User on User {
    profile {
      ... on ClientProfile {
        participantAttributes {
          displayName
        }
      }
    }
  }
`;

export const about = gql`
  fragment User on User {
    paymentToken
    profile {
      ... on ClientProfile {
        id
        participantAttributes {
          id
          firstName
          aboutSocialNeeds
          interests
          firstLanguages
          culturalBackgrounds
        }
      }
    }
  }
`;

export const houseHold = gql`
  fragment User on User {
    profile {
      ... on ClientProfile {
        id
        accessInformation
        emergencyInstructions
        equipmentList
        householdParking
        householdAccess
        householdEquipment
        householdSmokers
        householdDog
        householdCat
        householdPetsOthers
        householdPremisesConsideredSafe
      }
    }
  }
`;

export const ScheduleCall = gql`
  fragment User on User {
    calendlyLink
  }
`;

export const petsDetails = gql`
  fragment User on User {
    profile {
      ... on ClientProfile {
        id
        householdDog
        householdCat
        householdPetsOthers
      }
    }
  }
`;
